var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.667,
    r: 15,
    fill: "#BF83FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12.667C17 14.3238 15.6569 15.667 14 15.667C12.3431 15.667 11 14.3238 11 12.667C11 11.0101 12.3431 9.66699 14 9.66699C15.6569 9.66699 17 11.0101 17 12.667ZM14 16.417C11.1005 16.417 8.75 18.0959 8.75 20.167C8.75 20.9954 9.42157 21.667 10.25 21.667H17.75C18.5784 21.667 19.25 20.9954 19.25 20.167C19.25 18.0959 16.8995 16.417 14 16.417ZM20 11.167C20.4142 11.167 20.75 11.5028 20.75 11.917V12.667H21.5C21.9142 12.667 22.25 13.0028 22.25 13.417C22.25 13.8312 21.9142 14.167 21.5 14.167H20.75V14.917C20.75 15.3312 20.4142 15.667 20 15.667C19.5858 15.667 19.25 15.3312 19.25 14.917V14.167H18.5C18.0858 14.167 17.75 13.8312 17.75 13.417C17.75 13.0028 18.0858 12.667 18.5 12.667H19.25V11.917C19.25 11.5028 19.5858 11.167 20 11.167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/userAdd.140c8a53e45e4d0b7c611ee0d0e1f419.svg";
export { ForwardRef as ReactComponent };